import React from 'react';
import { connect } from 'react-redux';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Row, Col } from 'reactstrap';
import { GLNumberActions } from '../_actions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/fontawesome-free-solid'

class DeleteGLNumberModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false
    };

    this.toggle = this.toggle.bind(this);
    this.deleteGLNumber = this.deleteGLNumber.bind(this);
  }

  toggle() {
    this.setState({
      modal: !this.state.modal
    });
  }

  deleteGLNumber() {
    console.log("DELETE");
    console.log(this.props.gl_number_id);
    this.props.delete(this.props.gl_number_id);
    this.toggle();
  }

  render() {
    return (
      <div>
        <Button color="danger" className="full-width" onClick={this.toggle}><FontAwesomeIcon icon={faTimes} color="white" size="lg" /></Button>
        <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
          <ModalHeader>Supprimer numéro GL</ModalHeader>
          <ModalBody>
            <div>Voulez-vous supprimer ce numéro GL?</div>
          </ModalBody>
          <ModalFooter>
            <Row>
              <Col>
                <Button color="danger" onClick={this.deleteGLNumber}>Supprimer</Button>
              </Col>
              <Col xs="6" className="text-center" >
                <Button color="secondary" onClick={this.toggle}>Annuler</Button>
              </Col>
            </Row>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
    return {};
}

const mapDispatchToProps = (dispatch) => {
  return {
    delete: (gl_number_id) => {
      dispatch(GLNumberActions.delete(gl_number_id))
    }
  }
}

const connectedDeleteGLNumberModal = connect(mapStateToProps, mapDispatchToProps)(DeleteGLNumberModal);
export { connectedDeleteGLNumberModal as DeleteGLNumberModal };
